<div class="firmware-modal__header">
  <h1 class="firmware-modal__title">{{ modalData.title | translate }}</h1>
</div>

<form
  class="firmware-modal"
  [formGroup]="firmwareFormGroup"
  (ngSubmit)="onSubmit()"
>
  <!-- Название -->
  <lib-input
    class="firmware-modal__input"
    type="text"
    formControlName="name"
    [placeholder]="'monitoring.firmware.modal.name' | translate"
    [label]="'monitoring.firmware.modal.name' | translate"
    [libSkeleton]="firmwareLoadingState() === LoadingState.LOADING"
    [readonly]="isReadonly"
  />

  <!-- Версия -->
  <lib-input
    class="firmware-modal__input"
    type="text"
    formControlName="version"
    [placeholder]="'monitoring.firmware.modal.version' | translate"
    [label]="'monitoring.firmware.modal.version' | translate"
    [libSkeleton]="firmwareLoadingState() === LoadingState.LOADING"
    [readonly]="isReadonly"
  />

  <!-- Модели -->
  @if (canReadEquipmentModels()) {
    <mon-equipment-model-selector
      [libSkeleton]="firmwareLoadingState() === LoadingState.LOADING"
      [controlEntity]="getControl('models')"
      [disabled]="isReadonly"
    />
  }

  <!-- Комментарий -->
  <div>
    <lib-textarea
      class="firmware-modal__input"
      formControlName="comment"
      [placeholder]="'monitoring.firmware.modal.comment' | translate"
      [label]="'monitoring.firmware.modal.comment' | translate"
      [libSkeleton]="firmwareLoadingState() === LoadingState.LOADING"
    />
    @if (
      getControl('comment').hasError('maxlength') &&
      (getControl('comment').dirty || getControl('comment').touched)
    ) {
      <p class="firmware-modal__error error-text">
        {{ 'monitoring.firmware.modal.comment-max-length-error' | translate }}
      </p>
    }
  </div>

  <!-- Загрузка файла -->
  <div
    class="firmware-modal__file"
    [libSkeleton]="firmwareLoadingState() === LoadingState.LOADING"
  >
    @if (isEditingMode && serverEntity) {
      <div class="firmware-modal__uploaded-file">
        <div>
          <div class="mb-8">{{ 'monitoring.firmware.modal.file-upload-loaded' | translate }}</div>
          <div class="firmware-modal__uploaded-file-name flex align-center gap-8">
            <span>{{ serverEntity.originFileName }}</span>
          </div>
        </div>

        <lib-icon-button
          [title]="'monitoring.firmware.download-firmware' | translate"
          class="suffix ml-auto firmware-modal__download"
          icon="download"
          [size]="24"
          [disabled]="isDownloadingFirmware()"
          (click)="downloadUploadedFirmware()"
        />
      </div>
    } @else {
      @if (!isReadonly) {
        <lib-file-upload
          class="firmware-modal__file-uploader"
          labelTranslateKey="monitoring.firmware.modal.file-upload-drag"
          buttonLabelTranslateKey="monitoring.firmware.modal.file-upload-button"
          loadedLabelTranslateKey="monitoring.firmware.modal.file-upload-loaded"
          allowedExtensionsPrefixTranslateKey="monitoring.firmware.modal.file-upload-extensions"
          [accept]="['.zip', '.bmu', '.bin']"
          [multiple]="false"
          formControlName="file"
        />
      }
    }
  </div>

  <!-- Actions -->
  <div class="firmware-modal__actions">
    @if (isEditingMode && !isReadonly) {
      <lib-icon-button
        (click)="deleteFirmware()"
        [disabled]="firmwareLoadingState() === LoadingState.LOADING"
        [title]="'monitoring.firmware.modal.delete-firmware' | translate"
        [libSkeleton]="firmwareLoadingState() === LoadingState.LOADING"
        icon="trash"
        [size]="24"
        buttonStyle="filled"
        type="button"
      />
    }

    @if (!isReadonly) {
      <lib-button
        class="firmware-modal__submit-button"
        [disabled]="invalidFormData || firmwareLoadingState() === LoadingState.LOADING"
        [libSkeleton]="firmwareLoadingState() === LoadingState.LOADING"
        buttonSize="large"
        buttonType="submit"
      >
        {{
          (isCreatingMode
            ? 'monitoring.firmware.modal.create-firmware'
            : 'monitoring.firmware.modal.save-firmware'
          ) | translate
        }}
      </lib-button>
    }
  </div>
</form>
